import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AbstractPageComponent, SdkDictionaryService } from '@dsivd/prestations-ng';

import { BusinessForm } from '../../model/business-form';
import { CadorReference } from '../../model/cador-reference';
import { LevelOfFrench } from '../../model/level-of-french';
import { RefCadorService } from '../../services/ref-cador/ref-cador.service';
import { ElementUtils } from '../../utils/element.utils';

@Component({
    templateUrl: './professional-project-page.component.html'
})
export class ProfessionalProjectPageComponent extends AbstractPageComponent<BusinessForm> implements OnInit {

    wholeValue = ElementUtils.wholeValue;

    projectTypes: CadorReference[];
    levelOfEducations: CadorReference[];
    levelsOfFrench: LevelOfFrench[];
    level0OfFrench: LevelOfFrench;
    levelA1OfFrench: LevelOfFrench;
    levelA2OfFrench: LevelOfFrench;
    levelB1OfFrench: LevelOfFrench;
    levelB2OfFrench: LevelOfFrench;
    levelC1OfFrench: LevelOfFrench;
    levelC2OfFrench: LevelOfFrench;

    constructor(
        protected activatedRoute: ActivatedRoute,
        private dictionaryService: SdkDictionaryService,
        private refCadorService: RefCadorService
    ) {
        super(activatedRoute);

        this.projectTypes = this.refCadorService.getProjectTypesSync();
        this.levelOfEducations = this.refCadorService.getLevelOfEducationsSync();
        this.level0OfFrench = new LevelOfFrench();
        this.level0OfFrench.valeur = 'Langue maternelle';
        this.levelA1OfFrench = new LevelOfFrench();
        this.levelA1OfFrench.valeur = 'A1 - niveau introductif ou découverte';
        this.levelA2OfFrench = new LevelOfFrench();
        this.levelA2OfFrench.valeur = 'A2 - niveau débutant';
        this.levelB1OfFrench = new LevelOfFrench();
        this.levelB1OfFrench.valeur = 'B1 - niveau intermédiaire';
        this.levelB2OfFrench = new LevelOfFrench();
        this.levelB2OfFrench.valeur = 'B2 - niveau courant';
        this.levelC1OfFrench = new LevelOfFrench();
        this.levelC1OfFrench.valeur = 'C1 - niveau avancé';
        this.levelC2OfFrench = new LevelOfFrench();
        this.levelC2OfFrench.valeur = 'C2 - niveau maîtrise';
        this.levelsOfFrench = [this.level0OfFrench, this.levelA1OfFrench, this.levelA2OfFrench,
            this.levelB1OfFrench, this.levelB2OfFrench, this.levelC1OfFrench, this.levelC2OfFrench];
    }


    ngOnInit(): void {
        super.ngOnInit();
        super.setPageTitle(this.dictionaryService.getKeySync('professional-project.title'));
    }

    newForm(): BusinessForm {
        return new BusinessForm();
    }
}
